export const SHADE_CIRCLE_COUNT = 7;
export const PERFECT_SHADE_CIRCLE_COUNT = 5;
